import React from "react";
import { api } from "./utils/api";

interface IExpression {
  id: number;
  keywords: string;
}

const Expressions = (_props?: any) => {
  const inputRef = React.useRef<HTMLInputElement>(null);
  const [expressions, setExpressions] = React.useState<IExpression[]>([]);
  const [newKeyword, setNewKeyword] = React.useState<string>("");
  const [error, setError] = React.useState<string>("");

  function fetchExpressions() {
    setError("");
    api
      .get<IExpression[]>("/expressions", { params: { search: "" } })
      .then((response) => setExpressions(response.data))
      .catch((err) => setError(err.message || "Failed to fetch keyword tracers."));
  }

  React.useEffect(() => {
    fetchExpressions();
    inputRef.current?.focus();
  }, []);

  function handleAdd(e: React.FormEvent) {
    e.preventDefault();
    const trimmed = newKeyword.trim();
    if (!trimmed) return;
    setError("");
    api
      .post<IExpression>("/expressions", { keywords: trimmed })
      .then(() => {
        setNewKeyword("");
        fetchExpressions();
      })
      .catch((err) => setError(err.message || "Failed to add keyword tracer."));
  }

  function handleDelete(id: number) {
    if (!window.confirm("Delete this keyword tracer?")) return;
    api
      .delete(`/expressions/${id}`)
      .then(() => fetchExpressions())
      .catch((err) => setError(err.message || "Failed to delete keyword tracer."));
  }

  return (
    <div className="p-2 h-full w-full overflow-auto">
      <form className="flex gap-2 items-end mb-4" onSubmit={handleAdd}>
        <div className="flex-grow">
          <label htmlFor="new-keyword" className="block mb-1">Keywords:</label>
          <input
            id="new-keyword"
            type="text"
            ref={inputRef}
            value={newKeyword}
            placeholder="e.g. AAPL | earnings"
            onChange={(e) => setNewKeyword(e.target.value)}
          />
        </div>
        <button type="submit" className="btn btn-primary">Add</button>
      </form>

      {error && <p className="text-red-500 mb-2">{error}</p>}

      {expressions.map((expr) => (
        <div key={expr.id} className="p-2 my-1 flex justify-between items-center border-b">
          <span>{expr.keywords}</span>
          <button
            type="button"
            className="btn btn-danger"
            onClick={() => handleDelete(expr.id)}
          >
            Delete
          </button>
        </div>
      ))}
    </div>
  );
};

export default Expressions;
